export default __webpack_public_path__ + "media/img/filetypes/doc-b773a715a0274cc68eff9e29b36facf7.svg";